import React from 'react';
import Tooltip from '../../muiComponents/Tooltip';
import useTranslate from '../../customHooks/useTranslate';

const ColumnText = props => {
    const { labelText, titleText } = props;
    const trnLabel = useTranslate(labelText);
    return (
        <Tooltip titleText={titleText}>
            <span className='table__header-column__text'>{trnLabel}</span>
        </Tooltip>
    );
};

export default ColumnText;
